var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransactionsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 478.3 486.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "transactions") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M457.61,175.14V69.59A45.66,45.66,0,0,0,412,24H127.08c-24.18,0-44,19.47-44,43.43L81.47,343.14H37.61a11,11,0,0,0-10.94,10.93v47.36a57.6,57.6,0,0,0,55,57.42V459H327.57v-.11a32.58,32.58,0,0,0,3.28.11,57.6,57.6,0,0,0,57.53-57.53V186h58.29a10.73,10.73,0,0,0,10.94-10.82ZM48.55,401.55V365.13H273.32v36.42a57.43,57.43,0,0,0,12.46,35.66H84.2a35.66,35.66,0,0,1-35.65-35.66Zm318-332v332a35.66,35.66,0,0,1-71.32,0V354.19a11,11,0,0,0-10.93-10.93H103.45l1.64-275.73a21.87,21.87,0,0,1,22.09-21.66H373.27a44.42,44.42,0,0,0-6.78,23.73Zm69.23,94.61H388.37V69.6a23.74,23.74,0,0,1,47.47,0v94.61Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M319.69,254.87H145.24a10.94,10.94,0,1,0,0,21.88H319.8a10.94,10.94,0,1,0-.11-21.88Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M319.69,210.13H145.24a10.94,10.94,0,0,0,0,21.88H319.8a10.94,10.94,0,1,0-.11-21.88Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M319.69,165.39H145.24a10.94,10.94,0,1,0,0,21.88H319.8a10.94,10.94,0,1,0-.11-21.88Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M319.69,120.65H145.24a10.94,10.94,0,0,0,0,21.88H319.8a10.94,10.94,0,1,0-.11-21.88Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M319.69,75.91H145.24a10.94,10.94,0,1,0,0,21.88H319.8a10.94,10.94,0,1,0-.11-21.88Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M250.78,299.61H145.23a10.94,10.94,0,1,0,0,21.88H250.78a10.94,10.94,0,0,0,0-21.88Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionsIcon);
export default __webpack_public_path__ + "static/media/transactionsIcon.1be7a71d500a6bf73c780079a9e16413.svg";
export { ForwardRef as ReactComponent };